module.exports = __webpack_public_path__ + "static/Truck31-b71225942b3c36958b1d7488d21080dc.png";